import {
  CREATE_ARTICLE,
  CREATE_ARTICLE_BLOCK, DELETE_ARTICLE,
  DELETE_ARTICLE_BLOCK,
  GET_ARTICLE_BLOCKS_FAIL,
  GET_ARTICLE_BLOCKS_REQUEST,
  GET_ARTICLE_BLOCKS_SUCCESS, GET_ARTICLES_FAIL, GET_ARTICLES_REQUEST, GET_ARTICLES_SUCCESS, UPDATE_ARTICLE,
  UPDATE_ARTICLE_BLOCK,
} from '../actions/articles';

const initialState = {
  articleBlocks: [],
  articles: [],
  gettingLoading: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ARTICLE_BLOCKS_REQUEST: {
      return {
        ...state,
        gettingLoading: true,
      };
    }
    case GET_ARTICLE_BLOCKS_SUCCESS: {
      return {
        ...state,
        gettingLoading: false,
        articleBlocks: action.payload,
      };
    }
    case GET_ARTICLE_BLOCKS_FAIL: {
      return {
        ...state,
        gettingLoading: false,
        error: action.payload,
      };
    }

    case GET_ARTICLES_REQUEST: {
      return {
        ...state,
        gettingLoading: true,
      };
    }
    case GET_ARTICLES_SUCCESS: {
      return {
        ...state,
        gettingLoading: false,
        articles: action.payload,
      };
    }
    case GET_ARTICLES_FAIL: {
      return {
        ...state,
        gettingLoading: false,
        error: action.payload,
      };
    }

    case CREATE_ARTICLE_BLOCK: {
      return {
        ...state,
        articleBlocks: [...state.articleBlocks, action.payload],
      };
    }
    case UPDATE_ARTICLE_BLOCK: {
      return {
        ...state,
        articleBlocks: state.articleBlocks.map((i) => (i._id === action.payload?._id ? action.payload : i)),
      };
    }
    case DELETE_ARTICLE_BLOCK: {
      return {
        ...state,
        articleBlocks: state.articleBlocks.filter((i) => i._id !== action.payload?._id),
      };
    }

    case CREATE_ARTICLE: {
      return {
        ...state,
        articles: [...state.articles, action.payload],
      };
    }
    case UPDATE_ARTICLE: {
      return {
        ...state,
        articles: state.articles.map((i) => (i._id === action.payload?._id ? action.payload : i)),
      };
    }
    case DELETE_ARTICLE: {
      return {
        ...state,
        articles: state.articles.filter((i) => i._id !== action.payload?._id),
      };
    }

    default: {
      return state;
    }
  }
}
